/* eslint-disable jsx-a11y/alt-text */

import { useEffect, useRef, useState } from "react";
import clearIcon from "../images/clear.svg";
import styles from "../styles/components/PromptGenerate.module.css";
import common from "../styles/Common.module.css";
import promptStyles from "../styles/components/PromptInputs.module.css";
import { useDispatch } from "react-redux";
import { updateLora } from '../reducers/lorasSlice';
const PromptGenerateItem = ({ character, selected, onRemove, onSelect}) => {

	// const [loraStrength, setLoraStrength] = useState(character.strength);
	
	const handleRemoveLora = (character) => {
		onRemove(character);
	}
	const dispatch = useDispatch();

	const updateLoraStrength = (value) => {
		dispatch(updateLora({key: character.key, strength: value}));
	}
	return (
		<div className={selected ? styles.promptGenerateCharacterSelected : styles.promptGenerateCharacter}
		onClick={()=>onSelect(character)}>
			<img src={character?.thumbnail}/>
			<div className={promptStyles.inlineStrength}>
				<label>Strength</label>
				<input value={character.strength} onChange={(e) => updateLoraStrength(e.target.value)}></input>
			</div>
			{!character.sticky &&
				<button className={common.closeButton} onClick={()=>handleRemoveLora(character)}>
					<img src={clearIcon} />
				</button>
			}
		</div>
		
	);
};

export default PromptGenerateItem;
